import { render, staticRenderFns } from "./UserAccessPage.vue?vue&type=template&id=d5ba1514&scoped=true"
import script from "./UserAccessPage.vue?vue&type=script&lang=js"
export * from "./UserAccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ba1514",
  null
  
)

export default component.exports